var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_6213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 5C17.4998 4.33696 17.2365 3.70107 16.7676 3.23223C16.2988 2.76339 15.6629 2.5 14.9998 2.5H4.99985C4.4965 2.50298 4.00578 2.65783 3.59189 2.94429C3.178 3.23075 2.86022 3.63547 2.68013 4.10551C2.50005 4.57554 2.46603 5.08899 2.58255 5.57867C2.69907 6.06835 2.96069 6.51145 3.33318 6.85V15C3.33318 15.663 3.59657 16.2989 4.06541 16.7678C4.53425 17.2366 5.17014 17.5 5.83318 17.5H14.1665C14.8296 17.5 15.4654 17.2366 15.9343 16.7678C16.4031 16.2989 16.6665 15.663 16.6665 15V6.85C16.927 6.61701 17.1358 6.332 17.2793 6.01334C17.4228 5.69469 17.498 5.34948 17.4998 5ZM4.99985 4.16667H14.9998C15.2209 4.16667 15.4328 4.25446 15.5891 4.41074C15.7454 4.56702 15.8332 4.77899 15.8332 5C15.8332 5.22101 15.7454 5.43298 15.5891 5.58926C15.4328 5.74554 15.2209 5.83333 14.9998 5.83333H4.99985C4.77883 5.83333 4.56687 5.74554 4.41059 5.58926C4.25431 5.43298 4.16651 5.22101 4.16651 5C4.16651 4.77899 4.25431 4.56702 4.41059 4.41074C4.56687 4.25446 4.77883 4.16667 4.99985 4.16667ZM14.9998 15C14.9998 15.221 14.912 15.433 14.7558 15.5893C14.5995 15.7455 14.3875 15.8333 14.1665 15.8333H5.83318C5.61217 15.8333 5.4002 15.7455 5.24392 15.5893C5.08764 15.433 4.99985 15.221 4.99985 15V7.5H14.9998V15Z",
    fill: "#202A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.775 10H8.225C7.82459 10 7.5 10.3246 7.5 10.725V10.9417C7.5 11.3421 7.82459 11.6667 8.225 11.6667H11.775C12.1754 11.6667 12.5 11.3421 12.5 10.9417V10.725C12.5 10.3246 12.1754 10 11.775 10Z",
    fill: "#202A3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_6213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveOutline);
export default __webpack_public_path__ + "static/media/archiveOutline.c538fdaa433c314d8b029600bd53f8b9.svg";
export { ForwardRef as ReactComponent };